module.exports = __webpack_public_path__ + "static/icon-urgent.a082e783.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-urgent.png
// module id = 293
// module chunks = 2